export interface FlashMessage {
  type: FlashMessageType;
  message: string;
}
export type FlashMessageType = 'INVOICE_CREATED' | 'FIXED_PROJECT_SCHEDULED';

export const FLASH_MESSAGES: Array<FlashMessage> = [
  {
    type: 'INVOICE_CREATED',
    message: 'Request has been successfully created and sent.',
  },
  {
    type: 'FIXED_PROJECT_SCHEDULED',
    message: 'Inspections has been scheduled and project has been accepted.',
  },
];

export const getMessageByType = (type: FlashMessageType): string => {
  return FLASH_MESSAGES.find((m) => m.type === type)?.message || '';
};
